import type { FeatureCollection } from "geojson";
import type { Map as MapboxMap } from "mapbox-gl";

export function useMapInitialFocus(
  getMap: () => MapboxMap | undefined,
  markers: Ref<FeatureCollection>,
  initialId: string | undefined,
  options: { zoom?: number } = {}
) {
  let did = false;

  watch(
    [getMap, markers],
    ([map, m]) => {
      if (did || !initialId || !map) return;
      const feature = m.features.find((f) => String(f.properties?.id) === initialId);
      if (!feature || feature.geometry.type !== "Point") return;
      const [lng, lat] = feature.geometry.coordinates as [number, number];
      map.jumpTo({ center: [lng, lat], zoom: options.zoom ?? 14 });
      did = true;
    },
    { immediate: true }
  );
}
